import { render } from "./org-edit.vue?vue&type=template&id=4727f9f5"
import script from "./org-edit.vue?vue&type=script&lang=js"
export * from "./org-edit.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__